export const CLASS_START_WAIT = "Please wait for the class to begin";
